import { Pipe, PipeTransform } from '@angular/core';

const UNIT_MAP: Record<string, string> = {
  'm2': 'm²', 'm3': 'm³',
  'cm2': 'cm²', 'cm3': 'cm³',
  'dm2': 'dm²', 'dm3': 'dm³',
  'mm2': 'mm²', 'mm3': 'mm³',
  'km2': 'km²', 'km3': 'km³',
};

@Pipe({ name: 'einheit', pure: true })
export class EinheitPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const lower = value.toLowerCase().trim();
    if (UNIT_MAP[lower]) return UNIT_MAP[lower];
    return value.replace(/(\d)\s*[xX]\s*(\d)/g, '$1 x $2');
  }
}
